import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _toArray from "/app/node_modules/@babel/runtime/helpers/esm/toArray.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classPrivateFieldInitSpec from "/app/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _classPrivateFieldGet from "/app/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _classPrivateFieldSet from "/app/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.weak-map.js";
import "core-js/modules/web.dom-collections.iterator.js";
// Copyright 2017-2022 @polkadot/api authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { isFunction } from '@polkadot/util';

var _allHasFired = /*#__PURE__*/new WeakMap();

var _callback = /*#__PURE__*/new WeakMap();

var _fired = /*#__PURE__*/new WeakMap();

var _fns = /*#__PURE__*/new WeakMap();

var _isActive = /*#__PURE__*/new WeakMap();

var _results = /*#__PURE__*/new WeakMap();

var _subscriptions = /*#__PURE__*/new WeakMap();

export var Combinator = /*#__PURE__*/function () {
  function Combinator(fns, callback) {
    var _this = this;

    _classCallCheck(this, Combinator);

    _classPrivateFieldInitSpec(this, _allHasFired, {
      writable: true,
      value: false
    });

    _classPrivateFieldInitSpec(this, _callback, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _fired, {
      writable: true,
      value: []
    });

    _classPrivateFieldInitSpec(this, _fns, {
      writable: true,
      value: []
    });

    _classPrivateFieldInitSpec(this, _isActive, {
      writable: true,
      value: true
    });

    _classPrivateFieldInitSpec(this, _results, {
      writable: true,
      value: []
    });

    _classPrivateFieldInitSpec(this, _subscriptions, {
      writable: true,
      value: []
    });

    _classPrivateFieldSet(this, _callback, callback); // eslint-disable-next-line @typescript-eslint/require-await


    _classPrivateFieldSet(this, _subscriptions, fns.map( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(input, index) {
        var _ref2, _ref3, fn, args;

        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _ref2 = Array.isArray(input) ? input : [input], _ref3 = _toArray(_ref2), fn = _ref3[0], args = _ref3.slice(1);

                _classPrivateFieldGet(_this, _fired).push(false);

                _classPrivateFieldGet(_this, _fns).push(fn); // Not quite 100% how to have a variable number at the front here
                // eslint-disable-next-line @typescript-eslint/no-unsafe-return,@typescript-eslint/ban-types


                return _context.abrupt("return", fn.apply(void 0, _toConsumableArray(args).concat([_this._createCallback(index)])));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()));
  }

  _createClass(Combinator, [{
    key: "_allHasFired",
    value: function (_allHasFired2) {
      function _allHasFired() {
        return _allHasFired2.apply(this, arguments);
      }

      _allHasFired.toString = function () {
        return _allHasFired2.toString();
      };

      return _allHasFired;
    }(function () {
      _classPrivateFieldGet(this, _allHasFired) || _classPrivateFieldSet(this, _allHasFired, _classPrivateFieldGet(this, _fired).filter(function (hasFired) {
        return !hasFired;
      }).length === 0);
      return _classPrivateFieldGet(this, _allHasFired);
    })
  }, {
    key: "_createCallback",
    value: function _createCallback(index) {
      var _this2 = this;

      return function (value) {
        _classPrivateFieldGet(_this2, _fired)[index] = true;
        _classPrivateFieldGet(_this2, _results)[index] = value;

        _this2._triggerUpdate();
      };
    }
  }, {
    key: "_triggerUpdate",
    value: function _triggerUpdate() {
      if (!_classPrivateFieldGet(this, _isActive) || !isFunction(_classPrivateFieldGet(this, _callback)) || !this._allHasFired()) {
        return;
      }

      try {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        _classPrivateFieldGet(this, _callback).call(this, _classPrivateFieldGet(this, _results));
      } catch (error) {// swallow, we don't want the handler to trip us up
      }
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe() {
      if (!_classPrivateFieldGet(this, _isActive)) {
        return;
      }

      _classPrivateFieldSet(this, _isActive, false); // eslint-disable-next-line @typescript-eslint/no-misused-promises


      _classPrivateFieldGet(this, _subscriptions).forEach( /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(subscription) {
          var unsubscribe;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.prev = 0;
                  _context2.next = 3;
                  return subscription;

                case 3:
                  unsubscribe = _context2.sent;

                  if (isFunction(unsubscribe)) {
                    unsubscribe();
                  }

                  _context2.next = 9;
                  break;

                case 7:
                  _context2.prev = 7;
                  _context2.t0 = _context2["catch"](0);

                case 9:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, null, [[0, 7]]);
        }));

        return function (_x3) {
          return _ref4.apply(this, arguments);
        };
      }());
    }
  }]);

  return Combinator;
}();